var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCorona = function SvgCorona(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.197 5.14792C15.0778 5.05959 14.9351 5.00859 14.7869 5.00138C14.6387 4.99417 14.4917 5.03108 14.3645 5.10742L11.2273 6.98992L8.62401 3.08467C8.5955 3.04192 8.54825 3.02242 8.51301 2.98867L9.23526 2.26567C9.30519 2.19516 9.34443 2.09986 9.34443 2.00055C9.34443 1.90123 9.30519 1.80594 9.23526 1.73542L8.26551 0.765672C8.19499 0.695736 8.0997 0.656494 8.00038 0.656494C7.90106 0.656494 7.80577 0.695736 7.73526 0.765672L6.76551 1.73542C6.69557 1.80594 6.65633 1.90123 6.65633 2.00055C6.65633 2.09986 6.69557 2.19516 6.76551 2.26567L7.48776 2.98867C7.45176 3.02242 7.40525 3.04192 7.37675 3.08467L4.77351 6.98992L1.63626 5.10742C1.50877 5.03149 1.36173 4.99483 1.21352 5.00204C1.06532 5.00924 0.922523 5.05998 0.803006 5.14792C0.68418 5.23654 0.594123 5.35823 0.544098 5.49777C0.494073 5.6373 0.486301 5.78849 0.521756 5.93242L2.02176 11.9324C2.10576 12.2662 2.40576 12.5009 2.75001 12.5009H13.25C13.5943 12.5009 13.8943 12.2669 13.9783 11.9324L15.4783 5.93242C15.5137 5.78849 15.5059 5.6373 15.4559 5.49777C15.4059 5.35823 15.3158 5.23654 15.197 5.14792Z",
    fill: "#F5E341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00012 13.2513H14.0001V14.7513H2.00012V13.2513Z",
    fill: "#F5E341"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorona, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/corona.9913762e.svg";
export { ForwardRef as ReactComponent };